<template>
    <div  class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <div class="bg-white rounded-2xl shadow-2xl  w-10/12 md:ax-w-2xl p-6">
            <!-- Header -->
            <div class="flex justify-between items-center mb-4">
                <h2 class="text-xl font-semibold text-black"> Rechercher une réservation</h2>
                <button @click="close" class="text-gray-400 hover:text-gray-600">&times;</button>
            </div>

            <!-- Barre de recherche -->
            <input v-model="search" @input="handleSearch" type="text" placeholder="numero de la table"
                class="w-full p-3 border rounded-xl text-black bg-gray-100 focus:outline-none focus:ring-2 focus:ring-black/70" />

            <!-- Résultats -->
            <div class="mt-6 max-h-80 overflow-y-auto divide-y">
                <div v-for="res in res" :key="res.id"
                    class="py-4 px-2  hover:bg-gray-50 flex justify-between items-center">
                    <div>
                        <div class="font-medium text-black">{{ res.user?.name }}</div>
                        <div class="text-sm text-gray-500">{{ res.user?.email }} | {{ res.place + ' place(s)' }} <span class="text-red-600">{{ res.ticket?.type }}</span></div>
                        <div class="text-xs mt-1" :class="res.utilisation == 0 ? 'text-green-600' : 'text-red-600'">
                            {{ res.utilisation == 0 ? '✅ pas utiliser' : '❌ reservation deja prise et utiliser' }}
                        </div>
                        <div class="font-medium text-black">
                            {{ $moment(res.created_at).format('DD/MM/YYYY HH:mm') }}
                        </div>
                    </div>
                    <div class="flex gap-2">
                        <button v-if="res.utilisation==0" @click="validate(res.id)"
                            class="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded-xl text-sm">
                            {{ $t('valider') }}
                        </button>
                    </div>
                </div>

                <div v-if="Object.keys(res).length === 0 && search.length > 0" class="text-center text-gray-500 mt-4">
                   {{ $t('aucunereservationtrouve') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            search: '',
            res: [],
        };
    },
    methods: {
        close() {
            this.search = '';
            this.res = [];
            this.$emit('closeSearchModal');
        },
        handleSearch() {

            if (this.search.length == 0) {
                this.res = [];
                return;
            }
            if (this.search.length < 1) return; // éviter les recherches trop courtes
            this.axios
                .get(this.$store.state.api+"/getReservationforNumberTable/"+parseInt(this.search))
                .then(({data})=>{
                    this.res = data
                }).catch((error)=>{
                    console.log(error)
                })
        },
        validate(id) {
            this.axios
            .put(this.$store.state.api+"/validateReservation/"+parseInt(id),)
            .then(() => {
                this.res.filter((item,index)=> {
                    if (item.id == id) {
                        this.res[index].utilisation = 1;
                        this.res[index].status = "ferme";
                    }
                })
            }).catch((error) => {
                console.log(error);
            });
        },

    }
};
</script>

<style scoped>
/* Ajout style Apple-like optionnel */
</style>